import React, { useState } from "react";
import data from "./data.json";
import { useNavigate } from "react-router-dom";

const UdharReport = () => {
  const { header, company, title, form, buttons, colors } = data;
  const [reportDate, setReportDate] = useState(form.date);
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex justify-center items-center px-3 sm:px-6 md:px-16 lg:px-48 xl:px-64"
      style={{ backgroundColor: colors.background }}
    >
      <div
        className="border-2 rounded-md w-full max-w-2xl p-3 sm:p-4 md:p-6 shadow-lg"
        style={{ borderColor: colors.border }}
      >
        <div className="border border-black rounded-md p-2 sm:p-3 bg-[#f5f9eb]">
          <div
            className="text-center text-[10px] sm:text-xs md:text-sm font-semibold border-b pb-1 mb-2 truncate"
            style={{ borderColor: colors.border }}
          >
            {header.softwareName} {header.contact}
          </div>

          <div
            className="text-center py-2 sm:py-3 rounded-md"
            style={{ backgroundColor: colors.headerBg }}
          >
            <h1 className="font-bold text-sm sm:text-base md:text-lg">
              {company.name}
            </h1>
            <p className="text-[11px] sm:text-sm italic mt-1">
              {company.type}
            </p>
          </div>
        </div>

        <div className="text-center text-base sm:text-lg md:text-xl font-bold border border-black rounded-md py-2 sm:py-3 my-4">
          {title}
        </div>

        <div className="border border-black p-3 rounded-md">
          <div className="flex flex-col sm:flex-row justify-center items-center gap-3 mb-6 w-full">
            <label className="font-medium text-sm sm:text-base whitespace-nowrap">
              {form.label}
            </label>
            <input
              type="date"
              value={reportDate}
              onChange={(e) => setReportDate(e.target.value)}
              className="border border-gray-400 px-2 py-1 text-center font-semibold bg-white text-blue-600 rounded-md w-full sm:w-48 md:w-56 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 justify-items-center">
            <button
              className="px-4 py-2 w-full sm:w-40 md:w-44 text-nowrap rounded-md font-semibold shadow-md hover:scale-105 transition-transform text-sm sm:text-base"
              style={{
                backgroundColor: colors.buttonBg,
                color: colors.buttonText,
              }}
            >
              {buttons.report}
            </button>
            <button
              className="px-4 py-2 w-full sm:w-40 md:w-44 rounded-md font-semibold shadow-md hover:scale-105 transition-transform text-sm sm:text-base"
              style={{
                backgroundColor: colors.buttonBg,
                color: colors.buttonText,
              }}
            >
              {buttons.netList}
            </button>
            <button
              onClick={() => navigate("/dashboard")}
              className="px-4 py-2 w-full sm:w-40 md:w-44 rounded-md font-semibold shadow-md hover:scale-105 transition-transform text-sm sm:text-base"
              style={{
                backgroundColor: colors.buttonBg,
                color: colors.buttonText,
              }}
            >
              {buttons.exit}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UdharReport;
